import React from 'react'
import { useTranslation } from 'react-i18next'

import { Column } from 'primereact/column'

import { NumberBodyTemplate } from '../../../../../../../../components/tableTemplates'
import { DeliveryForecastDespatchAdvicePackagingBatch } from '../../../../../../../../data/models'
import { ConfigurableTable } from '../../../../../../../../utils/wrapper'
import { TableConfig } from '../../../../../../../ui-config/data'

type Props = {
  batches?: DeliveryForecastDespatchAdvicePackagingBatch[]
  config: TableConfig
}

export const BatchesTable: React.FC<Props> = ({ batches, config }) => {
  const { t } = useTranslation()

  const headerTitle = t(
    'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.add.dialog.batches.table.title',
  )

  return (
    <ConfigurableTable
      config={config}
      data={batches}
      headerTitle={headerTitle}
      stateKey=""
      checkboxen
      dataKey="Id"
      editMode="row"
      className="mt-4"
    >
      <Column
        key="batchnumber"
        field="Batchnumber"
        header="Batchnumber"
        className="w-4"
      ></Column>
      <Column
        key="quantity"
        field="Quantity"
        header="Quantity"
        body={(rowData: DeliveryForecastDespatchAdvicePackagingBatch) =>
          NumberBodyTemplate(rowData.Quantity)
        }
        className="w-4"
      ></Column>
      <Column
        key="availableQuantity"
        field="AvailableQuantity"
        header="Available quantity"
        body={(rowData: DeliveryForecastDespatchAdvicePackagingBatch) => {
          const availableQuantity = rowData.OpenQuantity! - rowData.Quantity
          return <>{NumberBodyTemplate(availableQuantity)}</>
        }}
        className="w-4"
      ></Column>
    </ConfigurableTable>
  )
}
